var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconColorLut = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3378C8",
  d: "m12.365 21.289 6.809-8.08 1.039 4.04-1.915 3.283-3.69 1.235z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#21DC55",
  d: "m9.909 20.191 7.907-9.26 1.199 2.337-6.937 8.304z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E6FF00",
  d: "m8.111 17.656 7.853-9.128.18-.174 1.512 2.515-8.036 9.455z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E60000",
  d: "m7.655 16.557.417-3.44 2.387-3.293L13.909 6l1.767 2.143Q8.26 17.626 7.903 18q-.357.375-.248-1.443"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#041C4A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "m8.348 17.399 7.392-8.81M17.816 10.658 9.62 20.426M19.447 12.833l-6.965 8.3"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#E1E1E1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M14.527 6.255A.87.87 0 0 0 13.909 6a.87.87 0 0 0-.619.255c-1.162 1.177-5.881 6.173-5.881 9.832 0 3.458 2.91 5.913 6.5 5.913s6.5-2.455 6.5-5.913c0-3.66-4.72-8.655-5.882-9.832"
}))));
export { SvgIconColorLut as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-color-lut.svg";